angular.module('common.directives.omDatePicker', [])
    .directive('omDatePicker', function ($compile, $interpolate) {
        //We need a custom directive to wrap kendo-date-picker directive
        //to overcome the issues of the kendo creature.
        //
        //So we create our wrapper directive, compile it from template where we assign all the
        //properties assigned to our directive to the underlying kendo directive with necessary
        //fixes to overcome its issues to not to force user (application engineer) to do that.
        return {
            priority: 2000,
            restrict: 'AE',
            terminal: true,
            scope: false,
            compile: function compile(element, attrs) {
                //Creating input to assign kendo directive to
                var input = $("<input>").attr('kendo-date-picker', '');
                //Transfer all properties applied to the this input from our directive
                //skipping placeholder as it needs to be treated in different manner
                angular.forEach(attrs, function (value, name) {
                    if (!_.string.startsWith(name, '$')) {
                        input.attr(attrs.$attr[name], $interpolate(value));
                    }
                });

                //And finally for the kendo directive to be able to compile and build its DOM to
                //incorporate it around our input we created above, we need to put that input
                //into some container. Otherwise kendo directive will just not finish its compile routine.
                var inputContainer = $("<div></div>").append(input);

                //Actually do compile.
                var cmp = $compile(inputContainer);

                //And return a link function inside which we append the resulted element to our directive's 
                //container.
                return function postLink(scope, element, attrs, controller) {
                    element.append(cmp(scope));
                }
            }
        };
    });